var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "31px",
    viewBox: "0 0 29 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_trend") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-100, -214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.5,
    x: 105,
    y: 226,
    width: 7,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 107.5,
    y: 222,
    width: 1.5,
    height: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 107.5,
    y: 237,
    width: 1.5,
    height: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#000000",
    strokeWidth: 1.5,
    x: 116,
    y: 222,
    width: 7,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 118.5,
    y: 218,
    width: 1.5,
    height: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 118.5,
    y: 233,
    width: 1.5,
    height: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 107.5,
    y: 222,
    width: 1.5,
    height: 4,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 107.5,
    y: 222,
    width: 1.5,
    height: 4,
    rx: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrend);
export default __webpack_public_path__ + "static/media/icon_trend.6f437054dc65023d3197a595d89fd8db.svg";
export { ForwardRef as ReactComponent };